import { Routes, Route } from 'react-router-dom';
import BillingList from './pages/BillingList';
import CreateBill from './pages/CreateBill';
import ViewCreatedBill from './pages/ViewCreatedBill';
import ESignRedirect from './pages/ESignRedirect';

function BillingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BillingList />} />
       <Route path="/viewCreatedBill" element={<ViewCreatedBill />} />
       <Route path="/viewCreatedBill/:billId" element={<ViewCreatedBill />} />
       <Route path="/create" element={<CreateBill />} />
      <Route path="/sign" element={<ESignRedirect />} />
    </Routes>

    
  );
}


export default BillingRoutes;
